import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button";
import { useTranslation } from "react-i18next";
import * as URLS from "../../../../urls";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  deleteCartService,
  getMyCartService,
} from "redux/services/general_service";
import { toast } from "react-toastify"; // Ensure you have toast notifications

const CartItem = ({
  item,
  onUpdateQuantity,
  onRemoveItem,
  onMoveToWishlist,
  loadCartData,
}) => {
  const { t, i18n } = useTranslation();
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const [quantity, setQuantity] = useState(item.quantity);
  const isRTL = i18n.language === "ar";

  const lang = i18n.language == "en-US" ? "en" : "ar";

  const handleQuantityChange = async (newQuantity) => {
  
    if (newQuantity < 1 || newQuantity > 99) return;
    setIsUpdating(true);

    if (isAuthenticated) {
      // API call to update quantity
      try {
        const formData = new FormData();
        formData.append("cart_id", item?.cart_id);
        formData.append("quantity", newQuantity);
        formData.append("_method", "PUT");

        const response = await axios.post(
          `${URLS.baseUrl}/${URLS?.cartURL}/update`,
          formData,
          {
            headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        );

        if (response?.status === 200 || response?.status === 201) {
          setQuantity(newQuantity);
           loadCartData();
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 422) {
            const validationErrors = error.response.data.errors;
            if (validationErrors) {
              Object.keys(validationErrors).forEach((key) => {
                validationErrors[key].forEach((message) => {
                  toast(t(message));
                });
              });
            }
          }
        }
      }
    } else {
      // Update localStorage
      const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
      const updatedCartItems = cartItems.map((cartItem) =>
        cartItem.id === item.id
          ? { ...cartItem, quantity: newQuantity }
          : cartItem
      );

      localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
      localStorage.setItem(
        "cartCount",
        updatedCartItems
          .reduce((total, cartItem) => total + cartItem.quantity, 0)
          .toString()
      );

      window.dispatchEvent(
        new CustomEvent("cartUpdated", {
          detail: {
            count: updatedCartItems.reduce(
              (total, cartItem) => total + cartItem.quantity,
              0
            ),
            items: updatedCartItems,
          },
        })
      );

      setQuantity(newQuantity);
    }

    setIsUpdating(false);
  };

  const handleRemove = () => {

      dispatch(deleteCartService({ cart_id: item?.cart_id }))
        .then((response) => {
          if (
            response?.payload?.status === 200 ||
            response?.payload?.status === 204
          ) {
            loadCartData();
            toast.success(t("removeed_item"));
          }
        })
        .catch((error) => {
          console.error("Error removing item from cart:", error);
          toast.error(t("Failed to remove item"));
        });
     /*else {
      try {
        const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
        const itemIndex = cartItems.findIndex(
          (cartItem) => cartItem.id === item.id
        );

        if (itemIndex !== -1) {
          cartItems.splice(itemIndex, 1);
          localStorage.setItem("cartItems", JSON.stringify(cartItems));
          const newCount = cartItems.reduce(
            (total, cartItem) => total + cartItem.quantity,
            0
          );
          localStorage.setItem("cartCount", newCount.toString());

          window.dispatchEvent(
            new CustomEvent("cartUpdated", {
              detail: {
                count: newCount,
                items: cartItems,
              },
            })
          );

          loadCartData();
          toast.success(t("Item removed successfully"));
        }
      } catch (error) {
        console.error("Error removing item from localStorage:", error);
        toast.error(t("Failed to remove item"));
      }
    }*/
  };
  const hasDiscount = isAuthenticated
    ? item?.product?.has_discount
    : item.has_discount;
  const subtotal = hasDiscount
    ? isAuthenticated
      ? item.product.price_after_discount * quantity
      : item.price_after_discount * quantity
    : isAuthenticated
    ? item?.product?.price * quantity
    : item.price * quantity;

  useEffect(() => {
    console.log(quantity);
  }, [quantity]);
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-[16px] shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden ${
        isRTL ? "text-right" : "text-left"
      }`}
    >
      <div className="flex flex-col md:flex-row gap-4 p-4">
        {/* Product Image */}
    <div className={`flex-shrink-0 ${isRTL ? "md:ml-4" : "md:mr-4"}`}>
  <div className="w-full md:w-28 h-32 rounded-lg relative"> {/* أزل overflow-hidden */}
    <Image
      src={
         item?.product && item?.product?.images[0]?.file_path
      }
      alt={item.name}
      className="w-full h-full object-fill"
    />
    {hasDiscount && (
      <div className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold z-50 select-none">
        {isAuthenticated
          ? (((item.product?.price - item.product?.price_after_discount) / item.price) * 100).toFixed(0)
          : (((item.price - item.price_after_discount) / item.price) * 100).toFixed(0)}
        % OFF
      </div>
    )}
  </div>
</div>

        {/* Product Details */}
        <div className="flex-1 flex flex-col">
          <div className="flex-1">
            {/* Header Row */}
            <div className="flex justify-between items-start">
              <h3
                className={`text-lg font-semibold text-gray-900 dark:text-white mb-1 line-clamp-2 ${
                  isRTL ? "text-right" : "text-left"
                }`}
              >
                {item.name}
              </h3>
              <div
                className={`text-lg font-bold ${isRTL ? "ml-2" : "mr-2"} ${
                  hasDiscount
                    ? "text-emerald-600"
                    : "text-gray-900 dark:text-white"
                }`}
              >
                {isAuthenticated
                  ? hasDiscount
                    ? item?.product?.price_after_discount
                    : item?.product?.price
                  : item.price_after_discount || item.price}{" "}
                {t("IQD")}
              </div>
            </div>

            {/* Variant Chips */}
            <div
              className={`flex flex-wrap gap-2 my-3 ${
                isRTL ? "justify-end" : "justify-start"
              }`}
            >
              {item?.attributes?.map((attribute) => (
                <span
                  key={attribute.id}
                  className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium 
                  ${isRTL ? "ml-2" : "mr-2"} 
                  bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100`}
                >
                  {attribute.values.map((value) => (
                    <span key={value.id}>{value.translations[lang].value}</span>
                  ))}
                </span>
              ))}
            </div>

            {/* Original Price */}
            {hasDiscount && (
              <div
                className={`text-sm text-gray-500 dark:text-gray-400 line-through ${
                  isRTL ? "text-right" : "text-left"
                }`}
              >
                {item.price} {t("IQD")}
              </div>
            )}
          </div>

          {/* Bottom Controls */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between pt-3 mt-3 border-t border-gray-200 dark:border-gray-700">
            {/* Quantity Controls */}
            <div
              className={`flex items-center ${
                isRTL ? "sm:ml-auto" : "sm:mr-auto"
              } mb-3 sm:mb-0`}
            >
              <button
                onClick={() => handleQuantityChange(quantity - 1)}
                disabled={quantity <= 1 || isUpdating}
                className="p-2 text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 rounded-lg transition-colors"
              >
                <Icon
                  name="Minus"
                  size={16}
                  className="text-gray-700 dark:text-gray-300"
                />
              </button>

              <span className="text-lg font-bold text-gray-900 dark:text-white mx-2">
                {quantity}
              </span>

              <button
                onClick={() => handleQuantityChange(quantity + 1)}
                disabled={quantity >= 99 || isUpdating}
                className="p-2 text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 rounded-lg transition-colors"
              >
                <Icon
                  name="Plus"
                  size={16}
                  className="text-gray-700 dark:text-gray-300"
                />
              </button>

              {isUpdating && (
                <div
                  className={`flex items-center gap-2 text-sm text-gray-500 ${
                    isRTL ? "mr-3" : "ml-3"
                  }`}
                >
                  <div className="w-4 h-4 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
                  {t("updating")}...
                </div>
              )}
            </div>

            {/* Subtotal and Actions */}
            <div className="flex items-center justify-between sm:justify-end space-x-4">
              <div
                className={`flex flex-col ${
                  isRTL ? "text-left ml-2" : "text-right mr-2"
                }`}
              >
                <span className="text-xs text-gray-500">{t("subtotal")}</span>
                <span className="text-lg font-bold text-gray-900 dark:text-white">
                  {subtotal} {t("IQD")}
                </span>
              </div>

              <div className="flex space-x-2">
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="Trash2"
                  iconPosition="left"
                  onClick={handleRemove}
                  className={`text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 ${
                    isRTL ? "flex-row-reverse" : ""
                  }`}
                >
                  <span className={`${isRTL ? "mr-2" : "ml-2"}`}>
                    {t("remove")}
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
